import { CommonModule } from '@angular/common';
import { Component, OnInit, Input, ContentChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { ErrorValidationService } from 'src/app/services/error-validation.service';

@Component({
  selector: 'error-messages',
  templateUrl: './error-messages.component.html',
  styleUrls: ['./error-messages.component.scss'],
  imports: [IonicModule, CommonModule],
  standalone: true
})
export class ErrorMessagesComponent {
  @Input() control?: FormControl;
  @Input() fieldName?: string;
  constructor(private errorValidationService: ErrorValidationService) {}

  get errorMessage() {
    const errors = Object.entries(this.control?.errors || {});
    const formControlName = this.fieldName || 'This field';

    if(!this.control) return '';
    if (!this.control.dirty && !this.control.touched) return '';
    if (!errors.length) return null;

    return this.errorValidationService.getErrorValidationMessage(formControlName, errors);

  }

}
